/**
 * Send GA4 event to GTM
 * @param {Object} object GA4 data object
 */
function ga4EventPush(object) {
    if (!object || !object.event) {
        return;
    }
    object.timestamp = Date.now();

    // Clear the previous ecommerce object as suggested by google
    window.dataLayer.push({ ecommerce: null });
    // Send data to GTM
    window.dataLayer.push(object);
    // eslint-disable-next-line no-console
    console.table(window.dataLayer);

}

/**
 * @description push in the data layer the impression of the page
 * @param visitorStatus {String} the status of the user: if it is logged is the customerID, guest if not
 * @param pageType {String} the type of the page, look at analytics-mapping for more information
 * @param url {String} the url of the page
 * @param userEmail {String} the user's email if logged, empty otherwhise
 */
function pageImpression(visitorStatus, pageType, url, userEmail) {
    window.dataLayer.push({
        'event': 'basicPageData',
        'visitorStatus': visitorStatus || 'guest',
        'pageType': pageType,
        'pageURL': url,
        'email': userEmail || ''
    });
}

/**
 * @description push in the data layer the business hours data
 * @param businessHours object is a json that should have a structure like that:
 * {'freshchat': {'on': { 'days': {'mo': '7-12, 12:30-17', 'tu': '8-16', ...}}, 'off': { 'days': [ '14.5', '24.12', '11.4:: 7-18' ] }}}
 */
function businessHours(businessHours) {
    if (businessHours) {
        window.dataLayer.push({
            'event': 'businessHours',
            'businessHours': businessHours
        });
    }
}

/**
 * @description track the search data
 * @param isCategorySearch {Boolean} set true only if the user has landed on page by clicking a category
 * @param keyWord {String} the argoument of the search (could be the category name or the keyword inserted in the searchBar)
 * @param categoryID {String} the id of the category clicked (set null if it is not a category search)
 * @param numberOfResults {Int} the number of results (only if it is not a category search)
 */
function search(isCategorySearch, keyWord, categoryID, numberOfResults) {
    if (isCategorySearch) {
        window.dataLayer.push({
            'event': 'search',
            'categoryID': categoryID,
            'categoryName': keyWord,
            'ecommerce': {
                'search_term': keyWord
            }
        });
    } else {
        window.dataLayer.push({
            'event': 'search',
            'searchKeyword': keyWord,
            'numberResults': numberOfResults,
            'searchType': 'site search',
            'ecommerce': {
                'search_term': keyWord
            }
        });
    }
}

/**
 * @description push in the data layer the impression of products
 * @param currencyCode {String} The unicode of the currency used
 * @param products {Object} contains collection of the products
 */
function trackProductImpression(currencyCode, products) {
    window.dataLayer.push({
        'event': 'ecommerceTrack',
        'ecommerce': {
            'currencyCode': currencyCode,
            'impressions': products
        }
    });
}

/**
 * @description push in the data layer the product variant data
 * @param currencyCode {String} The currency code used
 * @param products {Object} contains collection products
 */
function variantSelected(currencyCode, products) {
    window.dataLayer.push({
        'event': 'variantSelection',
        'ecommerce': {
            'currencyCode': currencyCode,
            'impressions': products,
            'detail': products
        }
    });
}

/**
 * @description track the event addToCart
 * @param currencyCode {String} The currency code used
 * @param products {Object} contains collection products
 * @param pageType {String} the current page type, null if the function is invoked inside the PDP
 * @param customerEmail {String} the customer email if logged
 * @param customerPhone {String} the customer phone if logged
 * @param arTryonInfo {arTryonInfo} object with the tryon flags
 */
function addToCart(currencyCode, products, pageType, customerEmail, customerPhone, arTryonInfo) {
    var eventData = {
        'event': 'addToCart',
        'email': customerEmail,
        'phone': customerPhone,
        'ecommerce': {
            'currencyCode': currencyCode,
            'add': {
                'products': products
            }
        }
    };

    //IN-AR TRY ON
    if (arTryonInfo) {
        eventData.tryOnDesktopClick = arTryonInfo.tryOnDesktopClick;
        eventData.tryOnMobileRedirect = arTryonInfo.tryOnMobileRedirect;
    }

    if (pageType) {
        eventData.ecommerce.actionField = {};
        eventData.ecommerce.actionField.list = pageType;
        eventData.ecommerce.actionField.action = 'add';
    }
    window.dataLayer.push(eventData);
}

/**
 * @description track the remove from cart
 * @param products {List} contains collection products
 */
function removeFromCart(products) {
    window.dataLayer.push({
        'event' : 'removeFromCart',
        'ecommerce': {
            'remove': {
                'products': products
            }
        }
    });
}

/**
 * @description push into the datalayer the checkout step data
 * @param step {int} The checkout's step
 * @param option {String} checkout's information, based on the steps
 * @param products {List} the products in the basket during the checkout
 */
function pushCheckoutData(step, option, products, customerEmail, customerPhone) {
    if (step === 1 && customerEmail && customerPhone) {
        window.dataLayer.push({
            'event' : 'ecommerceTrack',
            'email' : customerEmail,
            'phone' : customerPhone,
            'ecommerce': {
                'checkout': {
                    'actionField': {
                        'step': step,
                        'option': option,
                        'action': 'checkout'
                    },
                    'products': products
                }
            }
        });
    } else {
        window.dataLayer.push({
            'event' : 'ecommerceTrack',
            'ecommerce': {
                'checkout': {
                    'actionField': {
                        'step': step,
                        'option': option,
                        'action': 'checkout'
                    },
                    'products': products
                }
            }
        });
    }
}

/**
 * @description the standalone event for purchase, is launched always with the sixth checkout's step
 * @param purchaseData {Object} Purchase data:
 * id {String} the id of the order
 * revenue {Number} the revenue of the order
 * tax {Number} the tax total
 * shipping {Number} the order shipping cost
 * coupon {String} the name of the order coupon
 * products {List} a list of all products purchased
 * customerEmail {String} the customer email
 * customerPhone {String} the customer phone
 * adjustedMerchandizeTotalNetPrice {Decimal} order total net price
 * adjustedMerchandizeTotalTax {Decimal} order total tax
 */
function purchase(purchaseData) {
    window.dataLayer.push({
        'event' : 'ecommerceTrack',
        'email' : purchaseData.customerEmail,
        'phone' : purchaseData.customerPhone,
        'ecommerce': {
            'purchase': {
                'actionField': {
                    'id': purchaseData.id,
                    'affiliation': 'Bata',
                    'revenue': purchaseData.revenue,
                    'adjustedMerchandizeTotalNetPrice': purchaseData.adjustedMerchandizeTotalNetPrice,
                    'adjustedMerchandizeTotalTax': purchaseData.adjustedMerchandizeTotalTax,
                    'tax': purchaseData.tax,
                    'shipping': purchaseData.shipping,
                    'coupon': purchaseData.coupon.couponCodeName,
                    'action': 'purchase',
                },
                'products': purchaseData.products
            }
        }
    });
}

/**
 * @description registration of new user into the Bata club
 * @param userId {String} the id of the user
 * @param accountType {String} the type of account used by the user, regular user as default value
 * @param socialNetwork {String} The social network used by the user to sign up, empty string as default value
 */
function registration(userId, email, phone, accountType, socialNetwork) {
    window.dataLayer.push({
        'event': 'customerContact',
        'customerID': userId,
        'email': email,
        'phone': phone,
        'accountType': accountType || 'regular user',
        'socialNetwork': socialNetwork || ''
    });
}

/**
 * @description login user into the Bata club
 * @param userCrmId {String} the crm id of the user
 * @param accountType {String} the type of account used by the user, regular user as default value
 * @param socialNetwork {String} The social network used by the user to sign up, empty string as default value
 */
function login(customerCrmId, email, accountType, socialNetwork) {
    window.dataLayer.push({
        'event': 'loggedIn',
        'customerCrmId': customerCrmId,
        'email': email,
        'accountType': accountType || 'regular user',
        'socialNetwork': socialNetwork || ''
    });
}

/**
 * @description a product link is clicked from the user (exept from minicart)
 * @param currencyCode {String} The currency code used
 * @param pageType {String} the type of the page, look at analytics-mapping for more information
 * @param products {List} the list that contains the product clicked
 */
function productClick(currencyCode, pageType, products) {
    window.dataLayer.push({
        'event' : 'productClick',
        'ecommerce': {
            'currencyCode': currencyCode,
            'click': {
                'actionField': {
                    'list': pageType,
                    'action': 'click'
                },
                'products': products
            }
        }
    });
}

/**
 * @description register the impression of the promotions in PDP
 * @param promotions {List} A list of all the promotions displayed
 */
function promoImpression(promotions) {
    window.dataLayer.push({
        'event' : 'promoView',
        'ecommerce' : {
            'promoView': {
                'promotions': promotions
            }
        }
    });
}

/**
 * @description register the impression of a promotional banner
 */
function PageDesignerPromoImpression(promotions) {
    window.dataLayer.push({
        'event' : 'ecommerceTrack',
        'ecommerce' : {
            'promoView': {
                'promotions': promotions
            }
        }
    });
}

/**
 * @description register the click on a promotional banner
 */
function PageDesignerPromoClick(promotions) {
    window.dataLayer.push({
        'event': 'promotionClick',
        'ecommerce' : {
            'promoClick': {
                'promotions': promotions
            }
        }
    });
}

/**
 * @description the generic GAevent, take a look into the official documentation to understand his scope
 */
function trackGAEvent(category, action, label, eventValue, notInteraction) {
    window.dataLayer.push({
        'event': 'GAevent',
        'eventCategory': category || '',
        'eventAction': action || '',
        'eventLabel': label || '',
        'eventValue': eventValue || 0,
        'eventNotInteraction': notInteraction || false
    });
}

//
// Google Analytics 4

/**
 * GA4 add_payment_info event
 * @param {Object} checkoutData Checkout data
 * @param {Array.<Object>} items items Order items
 */
function ga4AddPaymentInfo(checkoutData, items) {
    ga4EventPush({
        'event': 'add_payment_info',
        'ecommerce': {
            'currency': checkoutData.currency,
            'payment_type': checkoutData.paymentType,
            'coupon': checkoutData.coupon,
            'payment_method_saved': checkoutData.paymentMethodSaved,
            'value': checkoutData.value,
            'items': items
        }
    });
}

/**
 * GA4 select_proceed_to_purchase
 * @param {Object} order  order data
 */
function ga4SelectProceedPurchase(order) {
    ga4EventPush({
        'event': 'select_proceed_to_purchase',
        'payment_type': order.defaultPaymentMethod,
        'shipping_tier': order.shipping[0].selectedShippingMethod.displayName
    });
}

function ga4SelectExpressCheckout(data) {
    ga4EventPush({
        'event': 'select_express_method',
        'payment_type': data.paymentType
    });
}

/**
 * GA4 add_shipping_info event
 * @param {Object} checkoutData Checkout data
 * @param {Array.<Object>} items items Order items
 */
function ga4AddShippingInfo(checkoutData, items) {
    ga4EventPush({
        'event': 'add_shipping_info',
        'ecommerce': {
            'currency': checkoutData.currency,
            'shipping': checkoutData.shipping,
            'shipping_tier': checkoutData.shippingTier,
            'coupon': checkoutData.coupon,
            'value': checkoutData.value,
            'items': items
        }
    });
}

/**
 * GA4 add_to_cart event
 * @param {String} currencyCode Two-letters currency code
 * @param {Number} value Product price
 * @param {Array.<Object>} items Products
 */
function ga4AddToCart(currencyCode, items, value) {
    ga4EventPush({
        'event': 'add_to_cart',
        'ecommerce': {
            'currency': currencyCode,
            'value': value,
            'items': items
        }
    });
}

/**
 * GA4 add_to_wishlist event
 * @param {String} currencyCode Two-letters currency code
 * @param {Number} value Product price
 * @param {Array.<Object>} items Products
 */
function ga4AddToWishlist(currencyCode, items, value) {
    ga4EventPush({
        'event': 'add_to_wishlist',
        'ecommerce': {
            'currency': currencyCode,
            'value': value,
            'items': items
        }
    });
}

/**
 * GA4 remove_from_wishlist event
 * @param {String} currencyCode Two-letters currency code
 * @param {Number} value Product price
 * @param {Array.<Object>} items Products
 */
function ga4RemoveFromWishlist(currencyCode, items, value) {
    ga4EventPush({
        'event': 'remove_from_wishlist',
        'ecommerce': {
            'currency': currencyCode,
            'value': value,
            'items': items
        }
    });
}

/**
 * GA4 begin_checkout event
 * @param {String} currencyCode Two-letters currency code
 * @param {String} coupon List of used order-level coupons separated by |
 * @param {Number} value Product price
 * @param {Array.<Object>} items Cart items
 */
function ga4BeginCheckout(currencyCode, items, coupon, value) {
    ga4EventPush({
        'event': 'begin_checkout',
        'ecommerce': {
            'currency': currencyCode,
            'coupon': coupon,
            'value': value,
            'items': items
        }
    });
}

/**
 * GA4 checkout_progress event
 * @param {Object} checkoutData Checkout data object
 * @param {Array.<Object>} items Cart items
 */
function ga4CheckoutProgress(checkoutData, items) {
    ga4EventPush({
        'event': 'checkout_progress',
        'step_label': checkoutData.stepLabel,
        'step_number': checkoutData.stepNumber,
        'ecommerce': {
            'currency': checkoutData.currencyCode,
            'coupon': checkoutData.coupon,
            'value': checkoutData.value,
            'items': items
        }
    });
}

/**
 * GA4 clear_search event
 */
function ga4ClearSearch() {
    ga4EventPush({'event': 'clear_search'});
}

/**
 * GA4 Save credit card information
 */
function ga4SaveCreditCard() {
    ga4EventPush({
        'event': 'save_credit_card',
    });
}

/**
 * GA4 login event
 * @param {Object} loginData Login data
 */
function ga4Login(loginData) {
    ga4EventPush({
        'event': 'login',
        'method': loginData.method,
        'login_type': loginData.loginType,
        'ecommerce': {
            'customerCrmId': loginData.customerCrmId
        }
    });
}

/**
 * GA4 purchase event
 * @param {Object} purchaseData Purchase related data
 * @param {Array.<Object>} items Order items
 */
function ga4Purchase(purchaseData, items) {
    ga4EventPush({
        'event': 'purchase',
        'ecommerce': {
            'currency': purchaseData.currency,
            'payment_type': purchaseData.paymentType,
            'shipping': purchaseData.shipping,
            'shipping_tier': purchaseData.shippingTier,
            'tax': purchaseData.tax,
            'transaction_id': purchaseData.transactionId,
            'coupon': purchaseData.coupon,
            'value': purchaseData.value,
            'adjustedMerchandizeTotalNetPrice': purchaseData.adjustedMerchandizeTotalNetPrice,
            'adjustedMerchandizeTotalTax': purchaseData.adjustedMerchandizeTotalTax,
            'bata_store': purchaseData.bataStore,
            'cart_id': purchaseData.cartId,
            'transaction_type': purchaseData.transactionType,
            'email': purchaseData.email,
            'items': items
        }
    });
}

/**
 * GA4 remove_from_cart event
 * @param {String} currencyCode Two-letters currency code
 * @param {Number} value Product price
 * @param {Array.<Object>} items Cart items
 */
function ga4RemoveFromCart(currencyCode, items, value) {
    ga4EventPush({
        'event': 'remove_from_cart',
        'ecommerce': {
            'currency': currencyCode,
            'value': value,
            'items': items
        }
    });
}

/**
 * GA4 select_item event
 * @param {String} currencyCode Two-letters currency code
 * @param {Array.<Object>} items Products
 */
function ga4SelectItem(currencyCode, items) {
    ga4EventPush({
        'event': 'select_item',
        'ecommerce': {
            'currency': currencyCode,
            'items': items
        }
    });
}

/**
 * GA4 select_colour event
 */
function ga4SelectColor(id, variant) {
    ga4EventPush({
        'event': 'select_color',
        'item_id': id,
        'item_variant': variant ? variant.toString() : ""
    });
}

/**
 * GA4 select_size event
 */
function ga4SelectSize(id, variant) {
    ga4EventPush({
        'event': 'select_size',
        'item_id': id,
        'item_variant': variant ? variant.toString() : ""
    });
}

/**
 * GA4 select_size_guide event
 */
function ga4SelectSizeGuide() {
    window.dataLayer.push({'event': 'select_size_guide'});
}

/**
 * GA4 select_content event
 * @param {Object} contentData Content related data
 */
function ga4SelectContent(contentData) {
    ga4EventPush({
        'event': 'select_content',
        'content_id': contentData.contentId,
        'content_type': contentData.contentType,
        'content_name': contentData.contentName
    });
}

/**
 * GA4 select_promotion event
 * @param {Object} promotionData promotion related data
 */
function ga4SelectPromotion(promotionData) {
    ga4EventPush({
        'event': 'select_promotion',
        'items': [{
            'creative_name': promotionData.promotionName,
            'creative_slot': promotionData.index,
            'location_id': promotionData.promotionId,
            'promotion_id': promotionData.promotionId,
            'promotion_name': promotionData.promotionName,
        }]
    });
}

/**
 * GA4 view_next_image_pdp event
 */
function ga4ViewNextImagePDP(imageData) {
    ga4EventPush({
        'event': 'view_next_image_pdp',
        'item_id': imageData.itemId,
        'item_variant': imageData.colorVariant,
    });
}

/**
 * GA4 select_size_wishlist event
 */
function ga4SelectWishlist() {
    window.dataLayer.push({'event': 'select_wishlist'});
}

/**
 * GA4 start search event
 */
function ga4StartSearch() {
    ga4EventPush({
        'event': 'start_search',
    });
}

/**
 * GA4 select_size_wishlist event
 */
function ga4SearchProduct(searchData) {
    ga4EventPush({
        'event': 'search',
        'search_term': searchData.searchTerm,
        'search_type': searchData.searchType
    });
}

/**
 * GA4 share event
 * @param {Object} shareData Product
 */
function ga4Share(shareData) {
    ga4EventPush({
        'event': 'share',
        'ecommerce': {
            'method': shareData.method,
            'content_type': shareData.contentType,
            'item_id': shareData.itemId,
            'element_id': shareData.elementId,
            'element_text': shareData.elementText,
            'link_url': shareData.linkUrl,
            'link_domain': shareData.linkDomain,
            'type': shareData.type
        }
    });
}

/**
 * GA4 sign_up event
 * @param {Object} registrationData data
 */
function ga4SignUp(registrationData) {
    ga4EventPush({
        'event': 'sign_up',
        'signup_form_type': registrationData.signupType,
        'ecommerce': {
            'customerCrmId': registrationData.customerCrmId
        }
    });
}

/**
 * GA4 sign_up event in checkout
 * @param {Object} registrationData data
 */
function ga4SignUpCheckout(registrationData) {
    ga4EventPush({
        'event': 'sign_up',
        'signup_form_type': registrationData.signupType
    });
}

/**
 * GA4 view_cart event
 * @param {String} currencyCode Two-letters currency code
 * @param {String} coupon List of used order-level coupons separated by |
 * @param {Number} value Product price
 * @param {Array.<Object>} items Cart items
 */
function ga4ViewCart(currencyCode, items, coupon, value) {
    ga4EventPush({
        'event': 'view_cart',
        'ecommerce': {
            'currency': currencyCode,
            'coupon': coupon,
            'value': value,
            'items': items
        }
    });
}

/**
 * GA4 view_item event
 * @param {String} currencyCode Two-letters currency code
 * @param {Array.<Object>} items Products
 */
function ga4ViewItem(currencyCode, items, value) {
    ga4EventPush({
        'event': 'view_item',
        'ecommerce': {
            'currency': currencyCode,
            'value': value,
            'items': items
        }
    });
}

/**
 * GA4 view_item_list event
 * @param {String} currencyCode Two-letters currency code
 * @param {Array.<Object>} items Products
 */
function ga4ViewItemList(currencyCode, items) {
    ga4EventPush({
        'event': 'view_item_list',
        'ecommerce': {
            'currency': currencyCode,
            'items': items,
            "results_number": items.length
        }
    });
}

/**
 * GA4 view_promotion event
 * @param {Array.<Object>} items Products
 */
function ga4ViewPromotion(items) {
    ga4EventPush({
        'event': 'view_promotion',
        'ecommerce': {
            'items': items
        }
    });
}

/**
 * GA4 page_view event
 * @param {Object} pageData Page data
 */
function ga4PageView(pageData) {
    ga4EventPush({
        'event': 'page_view_ga4',
        'page_type': pageData.pageType,
        'page_url': pageData.pageURL,
        'page_path': pageData.pagePath,
        'country': pageData.country,
        'email_marketing': pageData.emailMarketing,
        'email': pageData.email,
        'internal_client_id': pageData.internalClientId,
        'login_status': pageData.loginStatus,
        'user_gender': pageData.gender,
        'user_id': pageData.userID,
        'user_type': pageData.userType,
    });
}

/**
 * GA4 click_menu_nav event
 * @param {Number} menuLevel Menu level
 * @param {String} menuSelection Selected menu item name
 */
function ga4ClickMenuNav(menuLevel, menuSelection) {
    ga4EventPush({
        'event': 'click_menu_nav',
        'menu_level': menuLevel,
        'menu_selection': menuSelection
    });
}

/**
 * GA4 click_filter event
 * @param {String} filterCategory Input type (Checkbox or Slider or ...)
 * @param {String} filterName Filter name
 * @param {String} filterValue Filter selected value
 */
function ga4ClickFilter(filterCategory, filterName, filterValue) {
    ga4EventPush({
        'event': 'click_filter',
        'filter_category': filterCategory,
        'filter_name': filterName,
        'filter_value': filterValue
    });
}

/**
 * GA4 scroll event
 * @param {Number} percent Screen scrolled in percent
 */
function ga4Scroll(percent) {
    ga4EventPush({
        'event': 'scroll',
        'percent': percent
    });
}

/**
 * GA4 subscribe event
 * @param {String} subscription_type  Subscription type (newsletter)
 */
function ga4Subscribe(subscriptionType) {
    ga4EventPush({
        'event': 'subscribe',
        'subscription_type ': subscriptionType
    });
}

/**
 * GA4 open_pdp_image event
 */
function ga4OpenPdpImage() {
    ga4EventPush({'event': 'open_pdp_image'});
}

function ga4SuccessfulSearch(searchData) {
    ga4EventPush({
        'event': 'successful_search',
        'results_number': searchData.resultsNumber,
        'search_method': searchData.searchMethod,
        'search_term': searchData.searchTerm
    });
}

function ga4UnsuccessfulSearch(searchData) {
    ga4EventPush({
        'event': 'unsuccessful_search',
        'results_number': searchData.resultsNumber,
        'search_method': searchData.searchMethod,
        'search_term': searchData.searchTerm
    });
}

function ga4ClickBackInStock(clickBackInStockData) {
    ga4EventPush({
        'event': 'click_email',
        'element_id': clickBackInStockData.elementId,
        'element_text': clickBackInStockData.elementText,
        'link_url': clickBackInStockData.linkUrl
    });
}

function ga4ClickDiscoverBrand(discoverBrandData) {
    ga4EventPush({
        'event': 'click_menu_nav',
        'menu_level': discoverBrandData.menuLevel,
        'menu_selection': discoverBrandData.menuSelection,
    });
}

function ga4BrandLogoComponent(eventData) {
    ga4EventPush({
        'event': 'click_menu_nav',
        'menu_level': eventData.menuLevel,
        'menu_selection': eventData.menuSelection,
    });
}

function ga4SelectBrandName(brandData) {
    ga4EventPush({
        'event': 'select_brand_name',
        'page_type': 'product',
        'page_url': brandData.pageUrl,
        'button_position': brandData.buttonPosition,
    });
}

function ga4BrandSelectContent(selectContentData) {
    ga4EventPush({
        'event': 'select_content',
        'content_id': selectContentData.contentId,
        'content_type': selectContentData.contentType,
        'content_name': selectContentData.contentName
    });
}

/**
 * GA4 select_shop_at_bata event
 */
function ga4SelectShopAtBata() {
    ga4EventPush({
        'event': 'select_shop_at_bata',
    });
}

/**
 * GA4 select_news event
 * @param {Object} contentData Content related data
 */
function ga4SelectNews(contentData) {
    ga4EventPush({
        'event': 'select_news',
        'content_id': contentData.contentId,
        'content_type': contentData.contentType
    });
}

// End of Google Analytics 4

function ga4BrandSecondCategoryLevel(eventData) {
    ga4EventPush({
        'event': 'click_menu_nav',
        'menu_level': eventData.menuLevel,
        'menu_selection': eventData.menuSelection,
    });
}

/**
 * GA4 select_footer_menu event
 * @param {String} footer_selection Selected link
 * @param {String} level Wrapper of the link
 */
function ga4SelectFooterMenu(footer_selection, level) {

    let footerImg = footer_selection.find('img');
    if(footer_selection.text().trim().length > 0) {
        // If text, return text
        footer_selection = footer_selection.text();
    } else if (footerImg) {
        // If image, return title or alt attribute
        footer_selection = footerImg.attr('title') && footerImg.attr('title').length > 0 ? footerImg.attr('title') :
                            (footerImg.attr('alt') && footerImg.attr('alt').length > 0 ? footerImg.attr('alt') :
                            'image_without_text');
    } else {
        // Fallback if no text or image
        footer_selection = 'unknown_selection';
    }

    // Determine level of clicked link
    level = (level.text().trim().length > 0) ? level.text().trim() : 'unknown_level';

    dataLayer.push({
        'event': 'select_footer_menu',
        'footer_selection': footer_selection,
        'level': level
      });
}

// End of Google Analytics 4

/**
 * AB testing interaction dataLayer event
 * @param {Array} array of AB tests (from abTests)
 */
function abTestInteraction(list, pageType) {
    if (!list) {
        return;
    }

    list.forEach(function(item) {
        window.dataLayer.push({
            event: 'abTestInteraction',
            page_type: pageType && pageType.length > 0 ? pageType : 'other',
            variant_id: item.variant_id,
            variant_name: item.variant_name,
            version_type: item.version_type
        });
    });
}

module.exports = {
    productClick: productClick,
    search: search,
    pageImpression: pageImpression,
    trackProductImpression: trackProductImpression,
    promoImpression: promoImpression,
    PageDesignerPromoImpression: PageDesignerPromoImpression,
    PageDesignerPromoClick: PageDesignerPromoClick,
    variantSelected: variantSelected,
    addToCart: addToCart,
    removeFromCart: removeFromCart,
    pushCheckoutData: pushCheckoutData,
    purchase: purchase,
    registration: registration,
    login: login,
    trackGAEvent: trackGAEvent,
    ga4AddPaymentInfo: ga4AddPaymentInfo,
    ga4AddShippingInfo: ga4AddShippingInfo,
    ga4AddToCart: ga4AddToCart,
    ga4AddToWishlist: ga4AddToWishlist,
    ga4RemoveFromWishlist: ga4RemoveFromWishlist,
    ga4BeginCheckout: ga4BeginCheckout,
    ga4ClearSearch: ga4ClearSearch,
    ga4CheckoutProgress: ga4CheckoutProgress,
    ga4SaveCreditCard: ga4SaveCreditCard,
    ga4ClickBackInStock: ga4ClickBackInStock,
    ga4Login: ga4Login,
    ga4Purchase: ga4Purchase,
    ga4RemoveFromCart: ga4RemoveFromCart,
    ga4SelectItem: ga4SelectItem,
    ga4SelectColor: ga4SelectColor,
    ga4SelectSize: ga4SelectSize,
    ga4SelectContent: ga4SelectContent,
    ga4SelectPromotion: ga4SelectPromotion,
    ga4SelectWishlist: ga4SelectWishlist,
    ga4SearchProduct: ga4SearchProduct,
    ga4StartSearch: ga4StartSearch,
    ga4SuccessfulSearch: ga4SuccessfulSearch,
    ga4BrandSelectContent: ga4BrandSelectContent,
    ga4UnsuccessfulSearch: ga4UnsuccessfulSearch,
    ga4Share: ga4Share,
    ga4SignUp: ga4SignUp,
    ga4SignUpCheckout: ga4SignUpCheckout,
    ga4ViewNextImagePDP: ga4ViewNextImagePDP,
    ga4ViewCart: ga4ViewCart,
    ga4ViewItem: ga4ViewItem,
    ga4ViewItemList: ga4ViewItemList,
    ga4ViewPromotion: ga4ViewPromotion,
    ga4PageView: ga4PageView,
    ga4ClickMenuNav: ga4ClickMenuNav,
    ga4ClickFilter: ga4ClickFilter,
    ga4Scroll: ga4Scroll,
    ga4Subscribe: ga4Subscribe,
    ga4SelectSizeGuide: ga4SelectSizeGuide,
    ga4ClickDiscoverBrand: ga4ClickDiscoverBrand,
    ga4BrandLogoComponent: ga4BrandLogoComponent,
    ga4SelectBrandName: ga4SelectBrandName,
    ga4BrandSecondCategoryLevel: ga4BrandSecondCategoryLevel,
    ga4OpenPdpImage: ga4OpenPdpImage,
    businessHours: businessHours,
    abTestInteraction: abTestInteraction,
    ga4SelectProceedPurchase: ga4SelectProceedPurchase,
    ga4SelectFooterMenu: ga4SelectFooterMenu,
    ga4SelectShopAtBata: ga4SelectShopAtBata,
    ga4SelectNews: ga4SelectNews,
    ga4SelectExpressCheckout: ga4SelectExpressCheckout
};



// WEBPACK FOOTER //
// ./cartridges/app_bata_sfra/cartridge/client/default/js/analytics/analytics-events.js